/**
 * Stable lookup key for beer style names.
 */
export function toStyleNameKey(name) {
  return (name || '').trim().toLowerCase().replace(/\s+/g, ' ');
}
